import OnboardingSlide from './OnboardingSlide';
import ReviewDemoAnimation from './ReviewDemoAnimation';

export default function SlideReview() {
  return (
    <OnboardingSlide illustration={<ReviewDemoAnimation />} title="Review Before Saving">
      <p>
        After recording, Sawtna generates structured notes. Always <strong>review before saving</strong>.
      </p>
      <ul className="list-inside list-disc space-y-1 text-xs">
        <li>
          <strong>Hold the mic</strong> again to add more context — new speech merges into the note.
        </li>
        <li>Tap any section to edit text or fill in missing fields.</li>
        <li>Follow-up tasks appear at the bottom — review and remove any you do not need.</li>
        <li>Flags highlight critical values, high-alert meds, or items to verify.</li>
        <li>
          For multi-patient recordings, use the patient icons to switch between patients on the
          same review screen.
        </li>
      </ul>
      <p className="font-medium text-gray-700">When you are done:</p>
      <ul className="list-inside list-disc space-y-0.5 text-xs">
        <li>
          <strong>Check ✓</strong> — save to your session (notes, vitals, meds, and tasks update).
        </li>
        <li>
          <strong>Trash</strong> — discard this note and start over.
        </li>
      </ul>
    </OnboardingSlide>
  );
}
